import Enum from "../../../enums/Enum";

const EnumManagementType = new Enum({
    MEETING: {name: "Meeting"},
    MANAGEMENT_TIME: {name: "Management time"},
    EVENT: {name: "Event"},
    OTHER: {name: "Other"}
});

export default EnumManagementType;
